import React from 'react'
import { Link } from 'react-router-dom'
import Typography from 'material-ui/Typography'
import Grid from 'material-ui/Grid'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import Select from 'material-ui/Select'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormControlLabel, FormHelperText } from 'material-ui/Form'
import { MenuItem } from 'material-ui/Menu'
import Checkbox from 'material-ui/Checkbox'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { validateFormData } from '../../common/formtool'
import TermsAndCondition from './termsAndCondition'
import { toast } from "react-toastify";
import MFADialog from "../common/mfaDialog";
import InputPasswordField from '../common/inputpassword';

class SignupForm extends React.Component {

  state = {
    info: {
      firstname: "",
      lastname: "",
      emailaddress: "",
      contactnumber: "",
      companyname: "",
      language: "en-GB",
      password: "",
      confirmpassword: '',
      enabled: true,
      termsandconditions: false,
      units: "",
    },
    errors: {
      firstname: false,
      lastname: false,
      emailaddress: false,
      contactnumber: false,
      companyname: false,
      language: false,
      password: false,
      confirmpassword: false,
      termsandconditions: false,
      units: false,
    },
    enableSignup: false,
    error: false,
    weak: false,
    match: true,
    valid: true,
    signuperror: false,
    open: false,
    mfaDialogOpen: false,
  }

  handleChange = (name) => event => {
    const { errors, info } = this.state
    const { mfaVerified } = this.props

    errors[name] = false
    info[name] = name === 'termsandconditions' ? event.target.checked : event.target.value
    this.setState({
      info,
      errors,
      valid: true
    })
    if (name === 'termsandconditions') {
      this.setState({
        enableSignup: event.target.checked && this.props.mfaVerified
      })
    }

    if (name === 'emailaddress' && mfaVerified) {
      const {resetMfaState} = this.props;

      resetMfaState({})
    }
  }

  // Method to send OTP
  openMfaDialog = (e) => {
    const { requestOtpVerification } = this.props

    requestOtpVerification({
      emailAddress: this.state.info.emailaddress,
      contactNumber: this.state.info.contactnumber,
    })
  }

  handleSubmit(e) {
    e.preventDefault()
    const { translate, signup } = this.props
    const { errors, info } = this.state

    let validationerrors = validateFormData(info, {
      firstname: {
        required: translate('formfield_error_general_required')
      },
      lastname: {
        required: translate('formfield_error_general_required')
      },
      contactnumber: {
        required: translate('formfield_error_general_required')
      },
      emailaddress: {
        required: translate('formfield_error_general_required'),
        validEmail: translate('user_invalidemail_error')
      },
      companyname: {
        required: translate('formfield_error_general_required')
      },
      password: {
        required: translate('formfield_error_general_required')
      },
      confirmpassword: {
        required: translate('formfield_error_general_required')
      },
      termsandconditions: {
        required: translate('formfield_error_general_required')
      }
    })

    if (Object.keys(validationerrors).length) {
      Object.keys(validationerrors).map(err => {
        errors[err] = true
      })
      this.setState({
        errors,
        signuperror: false
      })
    } else if (info.confirmpassword !== info.password) {
      errors['password'] = true
      errors['confirmpassword'] = true
      this.setState({
        errors,
        valid: false,
        match: false,
        weak: false,
        signuperror: false
      })
    } else {
      let strong = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$")
      let valid = strong.test(info.confirmpassword)

      Object.keys(errors).map(key => {
        errors[key] = false
      })

      if (!valid) {
        errors['password'] = true
        errors['confirmpassword'] = true
        this.setState({
          error: true,
          valid: false,
          weak: true,
          signuperror: false,
          errors,
          info
        })
        return
      }

      this.setState({
        error: false,
        valid: true,
        weak: false,
        signuperror: false,
        errors
      })
      signup({
        ...info
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const { signuperror, mfaVerified, mfaVerificationRequested } = nextProps
    const { errors } = this.state
    if (signuperror) {
      switch (signuperror) {
        case 'error_duplicateuser':
          errors['emailaddress'] = true
          break;
      }
      this.setState({
        errors,
        valid: false,
        signuperror
      })
    }

    if (mfaVerificationRequested && !this.state.mfaDialogOpen ) {
      // toast.success("Account Verified Successfully")
      this.setState({
        mfaDialogOpen: true
      })
    }

    if (mfaVerified && this.state.mfaDialogOpen) {
      this.setState({
        mfaDialogOpen: false,
        enableSignup: this.state.info.termsandconditions
      })
    }
  }

  openSignupModal = () => {
    this.setState({
      open: true
    })
  }

  closeSignupModal = () => {
    this.setState({
      open: false
    })
  }

  closeMfaModal = () => {
    this.setState({
      mfaDialogOpen: false
    })
  }

  render() {
    const {
      classes,
      translate,
      activeLanguage,
      languages,
      mfaVerified,
    } = this.props
    const { errors, info, valid, error, weak, match, signuperror } = this.state

    let $modal = null
    if (this.state.open) {
      $modal = (
        <TermsAndCondition
          open={this.state.open}
          closeSignupModal={this.closeSignupModal}
          classes={classes}
          activeLanguage={activeLanguage}
          translate={translate}
        />
      )
    }

    let $mfaModal = null
    if (this.state.mfaDialogOpen) {
      $mfaModal = (
        <MFADialog
          open={this.state.mfaDialogOpen}
          closeMfaDialog={this.closeMfaModal}
          sendOtp={this.props.sendOtp}
          verifyOtp={this.props.verifyOtp}
          emailAddress={this.state.info.emailaddress}
          contactNumber={this.state.info.contactnumber}
          existingUser={false}
          activeLanguage={activeLanguage}
          translate={translate}
        />
      )
    }

    return (
      <div className={classes.root}>
        <form noValidate autoComplete="off" className={classes.formWrapper}>
          <Grid container className={classes.loginPage}>
            <Grid item className={classes.bigBlue} xs={6}>
              <Grid item className={classes.logo}>
                <img alt="" className={[classes.image]} src={'/images/login_logo.svg'} />
              </Grid>
              <Grid item className={classes.gears}>
                <img className={classes.image} alt="" src={'/images/gear.svg'} />
              </Grid>
            </Grid>
            <Grid item className={classes.loginRight} xs={6}>
              <Grid item className={classes.loginContainer}>
                <Grid item xs={12}>
                  <Typography type="headline" className={classes.headline} color="primary">
                    {translate('signup_welcome_title')}
                  </Typography>
                  <Typography gutterBottom>
                    {translate('already_have_an_account')}<Link className={classes.orangeLink} to="/login"> {translate('sign_in_here')}</Link>
                  </Typography>

                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  <TextField
                    error={errors['firstname']}
                    required
                    id="firstname"
                    label={translate('signup_firstname')}
                    className={classes.textField}
                    fullWidth
                    onChange={this.handleChange('firstname')}
                    value={info.firstname}
                  />
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  <TextField
                    error={errors['lastname']}
                    required
                    id="lastname"
                    label={translate('signup_lastname')}
                    className={classes.textField}
                    fullWidth
                    onChange={this.handleChange('lastname')}
                    value={info.lastname}
                  />
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  <TextField
                    error={errors['emailaddress']}
                    required
                    id="emailaddress"
                    label={translate('signup_emailaddress')}
                    className={classes.textField}
                    fullWidth
                    onChange={this.handleChange('emailaddress')}
                    value={info.emailaddress}
                  />
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  <TextField
                    error={errors['contactnumber']}
                    required
                    id="contactnumber"
                    label={translate('signup_contactnumber')}
                    className={classes.textField}
                    fullWidth
                    onChange={this.handleChange('contactnumber')}
                    value={info.contactnumber}
                  />
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  <TextField
                    error={errors['companyname']}
                    required
                    id="companyname"
                    label={translate('signup_companyname')}
                    className={classes.textField}
                    fullWidth
                    onChange={this.handleChange('companyname')}
                    value={info.companyname}
                  />
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="language">{translate("general_language")}</InputLabel>
                    <Select
                      value={info.language || 'en-GB'}
                      onChange={this.handleChange('language')}
                      input={<Input name="language" id="language" value={info.language} />}
                      displayEmpty
                      name="language"
                      className={classes.selectEmpty}
                    >
                                 {
                      languages.map((language, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={language.code}
                          >
                            {language.code}
                          </MenuItem>
                        )
                      })
                    }
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                {
                    !valid &&
                    (<Invalid translate={translate} error={error} weak={this.state.weak}
                      match={this.state.match} signuperror={signuperror} />)
                  }
                  <InputPasswordField
                    classes={classes}
                    error={errors['password']}
                    id="password"
                    label={translate('signup_password')}
                    onChange={this.handleChange('password')}
                    value={info.password}
                    helperText={translate('password_helper_text')}
                  />
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  <InputPasswordField
                    classes={classes}
                    error={errors['confirmpassword']}
                    id="confirmpassword"
                    label={translate('signup_confirmpassword')}
                    onChange={this.handleChange('confirmpassword')}
                    value={info.confirmpassword}
                    helperText={translate('password_helper_text')}
                  />
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        error={errors['termsandconditions']}
                        checked={info.termsandconditions}
                        onChange={this.handleChange('termsandconditions')}
                        value="termsandconditions"
                        color="primary"
                      />
                    }
                  />
                  <span className={classes.termsConditionLink}><a onClick={() => this.openSignupModal()}>{ translate('signup_terms_and_conditions')}</a></span>
                </Grid>
                <Grid item xs={12} className={classes.signupField}>
                  {!mfaVerified &&
                  <Button
                    type="button"
                    color="primary"
                    raised
                    disabled={!this.state.info.emailaddress || !this.state.info.contactnumber}
                    onClick={(e) => this.openMfaDialog(e)}
                  >
                    {translate('mfa_verify_account')}
                  </Button>}
                  { mfaVerified &&
                    <Button
                      type="button"
                      color="primary"
                      raised
                      disabled={true}
                    >
                      {translate('mfa_verified')}
                    </Button>
                  }

                  <Button
                    type="submit"
                    color="primary"
                    className={classes.signupButton}
                    raised
                    onClick={(e) => this.handleSubmit(e)}
                    disabled={!this.state.enableSignup}
                  >
                    {translate('signup_ok')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
        {$modal}
        {$mfaModal}
      </div>
    )
  }
}

const Invalid = ({ translate, signuperror, error, weak, match }) => {
  return (
    <Typography color="error" gutterBottom>
      {
        (signuperror) ? translate(signuperror) :
          (weak) ? (
            translate('reset_weak')
          ) : (!match) ? (
            translate('reset_match')
          ) : (
                translate('reset_error')
              )
      }
    </Typography>
  )
}

export default withStyles(styles)(SignupForm)



// WEBPACK FOOTER //
// ./src/components/signup/index.js